import { createContextualCan } from '@casl/react'

import { AbilityContext } from './abilityContext'
import { Actions } from './types/actions'
import { Subjects } from './types/subjects'

export type Can = (action: Actions | Actions[], subject: Subjects) => void

export const Can = createContextualCan(AbilityContext.Consumer)
